import {
  TEXT_BODY,
  TEXT_PRIMARY,
} from '../../lib/medievalTheme';

/**
 * Shared section wrapper used by every panel inside the statistics view.
 * Deliberately frameless. No border, plating, or panel fill. Sections are
 * separated by whitespace and their small-caps headings, so the dashboard
 * reads as one page instead of a wall of boxed widgets. The content padding
 * is kept because panel innards (chart negative margins, table insets) were
 * tuned against it.
 */
export function StatCard({ title, description, children, className = '', padding = 'p-4', headerAction }) {
  return (
    <section className={`relative ${className}`}>
      <div className={`relative ${padding}`}>
        {(title || headerAction) && (
          <div className="flex items-start justify-between gap-3 mb-3">
            <div>
              {title ? (
                <h3 className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>
                  {title}
                </h3>
              ) : null}
              {description ? (
                <p className="mt-1 text-xs leading-5" style={{ color: TEXT_BODY, opacity: 0.8 }}>
                  {description}
                </p>
              ) : null}
              {/* Short gold rule anchors the heading without boxing the
                  section. The one accent that separates sections now
                  that the frames are gone. */}
              <div
                aria-hidden="true"
                className="mt-1.5"
                style={{ width: '2.5cqw', height: '1px', background: 'rgba(180,140,60,0.4)' }}
              />
            </div>
            {headerAction || null}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}

export default StatCard;
